import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconPause = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 18C8.55228 18 9 17.5523 9 17V7.14811C9 6.59583 8.55228 6.14811 8 6.14811C7.44772 6.14811 7 6.59583 7 7.14811L7 17C7 17.5523 7.44772 18 8 18ZM16.0247 18C16.577 18 17.0247 17.5523 17.0247 17V7.14811C17.0247 6.59583 16.577 6.14811 16.0247 6.14811C15.4724 6.14811 15.0247 6.59583 15.0247 7.14811V17C15.0247 17.5523 15.4724 18 16.0247 18Z"
        />
      </svg>
    );
  }
);
